export const staffMembers = [
  {
    id: "practice7092022",
    type: "staffMembers",
    role: "Admin lead",
    title: "Shane Payen",
    email: "shane.payen@nhs.net"
  },
  {
    id: "practice7092023",
    type: "staffMembers",
    role: "Care coordinator",
    title: "Ellie Hatch-Mccarthy",
    email: "ellie.hatch-mccarthy@nhs.net"
  },
  {
    id: "practice7092024",
    type: "staffMembers",
    role: "Clinical Director",
    title: "Nayeem Azim",
    email: "nayeemazim@nhs.net"
  },
  {
    id: "practice7092025",
    type: "staffMembers",
    role: "Dementia",
    title: "Wadzanai Chamboko",
    email: "wadzanai.chamboko@nhs.net"
  },
  {
    id: "practice7092026",
    type: "staffMembers",
    role: "Dietician",
    title: "Judith Aslan",
    email: "judith.aslan1@nhs.net"
  },
  {
    id: "practice7092027",
    type: "staffMembers",
    role: "Health and Wellbeing Coach",
    title: "Waheeda Hewad",
    email: "waheeda.hewad@nhs.net"
  },
  {
    id: "practice7092028",
    type: "staffMembers",
    role: "MSK Practitioner",
    title: "Ghulam Adel",
    email: "ghulam.adel@nhs.net"
  },
  {
    id: "practice7092029",
    type: "staffMembers",
    role: "PCN Manager",
    title: "Abrahim Azim",
    email: "Abrahim.azim@nhs.net"
  },
  {
    id: "practice7092030",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Ahmed Sherman",
    email: "ahmed.sherman@nhs.net"
  },
  {
    id: "practice7092031",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Aisha Noor",
    email: "a.noor@nhs.net"
  },
  {
    id: "practice7092032",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Bhavesha Jiwan",
    email: "bhavesha.jiwan@nhs.net"
  },
  {
    id: "practice7092033",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Hamdi Moallim",
    email: "hamdi.moallim@nhs.net"
  },
  {
    id: "practice7092034",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Mayra Sherman",
    email: "mayra.sherman1@nhs.net"
  },
  {
    id: "practice7092035",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Minal Shah",
    email: "minal.shah@nhs.net"
  },
  {
    id: "practice7092037",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Sabbir Ahmed",
    email: "sabbir.ahmed@nhs.net"
  },
  {
    id: "practice7092038",
    type: "staffMembers",
    role: "Pharmacist",
    title: "Tejal Gor",
    email: "t.gor@nhs.net"
  },
  {
    id: "practice7092039",
    type: "staffMembers",
    role: "Social Prescriber",
    title: "Emma hatfield",
    email: "emma.hatfield4@nhs.net"
  },
  {
    id: "practice7092040",
    type: "staffMembers",
    role: "Social Prescriber",
    title: "Inass Ibrahim",
    email: "inass.ibrahim@nhs.net"
  },
  {
    id: "practice7092041",
    type: "staffMembers",
    role: "Social Prescriber",
    title: "Rebeqa Lovett",
    email: "rebeqa.lovett@nhs.net"
  }
]